import { render, staticRenderFns } from "./ClipboardMenu.vue?vue&type=template&id=2333573b&scoped=true&"
import script from "./ClipboardMenu.vue?vue&type=script&lang=ts&"
export * from "./ClipboardMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ClipboardMenu.vue?vue&type=style&index=0&id=2333573b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333573b",
  null
  
)

export default component.exports